import { Box, Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
// First, add this component inside your EsignReceivingEnd component
const ErrorModal = ({ open }) => {
  if (!open) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 20000, // Ensure modal appears above text fields (10000+) and other modals
      }}
    >
      <Box
        sx={{
          backgroundColor: "white",
          padding: 4,
          borderRadius: 2,
          maxWidth: 400,
          textAlign: "center",
        }}
      >
        <Box
          sx={{
            fontSize: 60,
            color: "#dc3545",
            mb: 2,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <ErrorOutlineIcon sx={{ fontSize: 60 }} />
        </Box>
        <Typography variant="h5" sx={{ mb: 2 }}>
          Document Unavailable
        </Typography>
        <Typography variant="body1" sx={{ mb: 3, color: "text.secondary" }}>
          This document has been deleted or archived by the sender and is no
          longer available.
        </Typography>
        {/* <Button
            variant="contained"
            onClick={() => window.location.href = "/dashboard"}
            sx={{
              bgcolor: '#dc3545',
              '&:hover': { bgcolor: '#bb2d3b' }
            }}
          >
            Return to Dashboard
          </Button> */}
      </Box>
    </Box>
  );
};
export default ErrorModal;
